import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import Grid from '@material-ui/core/Grid';
import TableFieldMeta from '../../common/TableFieldMeta';
import InnerTabFilterGridItemTextField from '../common/innerTab/InnerTabFilterGridItemTextField';
import BaseGridContainer from '../common/BaseGridContainer';
import { useCommonStyles } from '../common/Styles';
import { createQueryRendererProgressV2 } from '../common/QueryRendererProgressV2';
import TablePaginator from '../common/TablePaginator';
import { toLocal } from '../../helpers/ID';

function SelectedFactsetFundList(props) {
  const {
    relay,
    viewer,
    filter,
  } = props;

  filter.setRelay(relay);

  const classes = useCommonStyles();

  const columns = [
    TableFieldMeta.localId,
    TableFieldMeta.field('exchangeSymbol', 'Ex.Symbol', { accessor: node => node.factsetContract.exchangeSymbol }),
    TableFieldMeta.field('currency', 'Currency', { accessor: node => node.factsetContract.currency }),
    TableFieldMeta.field('isin', 'ISIN', { accessor: node => node.factsetContract.isin }),
    TableFieldMeta.field('name', 'Name', { accessor: node => node.factsetContract.name }),
    TableFieldMeta.field('fsId', 'Factset Contract ID', { accessor: node => toLocal(node.factsetContract.id) }),
  ];

  return (
    <div>
      <div className={classes.formControlContainer}>
        <BaseGridContainer>
          <InnerTabFilterGridItemTextField
            id="search-filter"
            label="Custom Search"
            helperText="id, symbol, factset-name"
            onChange={e => filter.updateVar('search', e.target.value)}
          />

          <InnerTabFilterGridItemTextField
            id="isin-search"
            label="ISIN"
            helperText="isin"
            onChange={e => filter.updateVar('isin', e.target.value || null)}
          />

        </BaseGridContainer>
      </div>

      <Grid item xs={12}>
        <TablePaginator
          columns={columns}
          filter={filter}
          getDataNode={() => (viewer ? viewer.factsetSupportedFundContracts : null)}
        />
      </Grid>

    </div>
  );
}


const query = graphql`
  query SelectedFactsetFundListQuery (
    $first: Int
    $offset: Int
    $search: String
    $isin: String
  ) {
    viewer {
      ...SelectedFactsetFundList_viewer
      @arguments (
        first: $first
        offset: $offset
        search: $search
        isin: $isin
      )
    }
  }
`;

const container = createRefetchContainer(
  SelectedFactsetFundList,
  {
    viewer: graphql`
      fragment SelectedFactsetFundList_viewer on Query      
      @argumentDefinitions(
        first: {type: Int, defaultValue: 10 }
        offset: {type: Int, defaultValue: 0 }
        search: {type: String}
        isin: {type: String}
      ) {
        factsetSupportedFundContracts (
          first: $first
          offset: $offset
          search: $search
          factsetContract_Isin: $isin
        ) {
          edges {
            node {
              id
              createdAt
              updatedAt
              factsetContract {
                exchangeSymbol
                fsymId
                id
                currency
                isin
                name
              }
            }
          }
          count
        }
      }
    `,
  },
  query,
);

SelectedFactsetFundList.propTypes = {
};

SelectedFactsetFundList.defaultProps = {
};

export default createQueryRendererProgressV2(
  query,
  container,
);
